import React from 'react'

export default function Logos(){
  if( typeof LOCATION_EXTRAS !== 'object' ) return null
  return (
    <section className="section-space" dangerouslySetInnerHTML={{__html: LOCATION_EXTRAS.logos}} />
  )
}
